module.exports = __webpack_public_path__ + "static/img/8.f792531.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/8.png
// module id = Csnr
// module chunks = 0